jQuery( window ).on( "load", function() { 	
			  
  var sizeUs = "";
  jQuery( "label.btooltip" ).each(function() {
  	var size = jQuery( this ).attr( "title" );

	switch (size) {
        case '39':
			sizeUs = '6½';
			break;
	  	case '40':
			sizeUs = '7';
			break;
		case '40.5':
			sizeUs = '7½';
			break;
		case '41':
			sizeUs = '8';
			break;
		case '41.5':
			sizeUs = '8½';
			break;
		case '42':
			sizeUs = '9';
			break;
		case '42.5':
			sizeUs = '9½';
			break;
		case '43':
			sizeUs = '10';
			break;
		case '43.5':
			sizeUs = '10½';
			break;
		case '44':
			sizeUs = '11';
			break;
		case '44.5':
			sizeUs = '11½';
			break;
		case '45':
			sizeUs = '12';
			break;
		case '46':
			sizeUs = '13';
        	break;
        case '47':
			sizeUs = '14';
        	break;
	  default:
	    console.log('No size found');
	}

    jQuery(this ).text( size + " ( US " + sizeUs  + " )");
  });

});
